import { HTMLAttributes } from 'react';
import { CardSize, CardVariant } from '../../enums';
import { CardBanner } from './CardBanner';
import { CardHeader } from './CardHeader';
import { CardBody } from './CardBody';
import styles from './styles.module.scss';
import { joinClassNames } from '../../utils';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Enum, CardSize (`CardSize.Small`, `CardSize.Medium`)
   */
  size?: CardSize;
  /**
   * Enum, CardVariant (`CardSize.Primary`, etc...)
   */
  variant?: CardVariant;
};

export const Card = ({
  children,
  size = CardSize.Medium,
  variant = CardVariant.Primary,
  className,
  ...props
}: CardProps) => {
  const classnames = joinClassNames(styles.card, styles[size], styles[variant], className);

  return (
    <div className={classnames} {...props}>
      {children}
    </div>
  );
};

Card.Banner = CardBanner;
Card.Header = CardHeader;
Card.Body = CardBody;
